const P = (e, l) => l != null && l.pricePlan ? l.pricePlan : e != null && e.pricePlan ? e.pricePlan : null;
export {
  P as getPhysicalProductPricePlan
};
